/**
 * Список отсутствующих путей
 */
export const NOT_FOUND_PATHS_OF_CATEGORY = {
  '/japan/rolly/': '/category/rolly/',
  '/japan/sushi/': '/',
  '/japan/sety/': '/category/sety/',
  '/japan/salaty/': '/category/salaty/',
  '/japan/supy/': '/category/supy/',
  '/filter/samovyvoz/': '/category/samovyvoz/',
  '/filter/kidsmenu/': '/category/kidsmenu/',
  '/lapsha/': '/category/wok/',
  '/japan/teploe/': '/',
  '/back/': '/support/',
  '/restoran/': '/',
  '/restoran': '/',
  '/akcii/': '/sales/',
}
